import { Portali } from './portali';

export class userData {
    ListaFunzioni: [
        {
            funzione: string;
            id_funzione: number;
            action: string;
            icona: string;
            isMenu: number;
            ordine: number;
        }
    ];
    ListaFunzioniMenu: [
        {
            funzione: string;
            id_funzione: number;
            action: string;
            icona: string;
            isMenu: number;
            ordine: number;
        }
    ];
    cognome: string;
    data_primo_accesso: Date;
    data_ultimo_accesso: Date;
    nome: string;
    utente: string;
    webApiToken: string;
    Portali: Portali[];

    constructor() {
        this.Portali = new Array<Portali>();
    }

    static hasAdministration(user: userData): boolean {
        return user.Portali.filter(x => x.userAdministrator).length > 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/user-data.ts